<!--  -->
<template>
  <div class=""></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    getUrl() {
      const { url } = this.$route.query;
      window.location.href=url
    },
  },
  created() {},
  mounted() {
    this.getUrl();
  },
};
</script>
